import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60aeeb4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "HomePage" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h3" }, "We are on an IOS Device", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h3" }, "We are on an Android Device", -1))
const _hoisted_7 = { key: 2 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "It looks like you are not in the app webview on a compatible device", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h3" }, "Domain :", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "h3" }, "User :", -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { computed, onMounted, ref } from 'vue';
import { requestAccessTokenGameCenter, requestWLDomain } from "@/bridge/AccessTokenHandler"
import { GetUser } from "@/api/ApiFetch"
import Delay from '@/core/Delay';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const isIOS = computed(() => typeof window.webkit !== 'undefined');
const isAndroid = computed(() => typeof window.Android !== 'undefined');

const domainName = ref<null | string>(null)
const token = ref<null | string>(null)
const tokenstr = ref<null | string>(null)
const userObj = ref<null | string>(null)

async function testGetAccessTokenGameCenter() {

  if (!isIOS.value && !isAndroid.value) return;

  if (token.value === null) {
    const t = await getAccessTokenGameCenter(token.value !== null);
    token.value = t
    setTokenStr(t)
  }

  const userjson: Response = await GetUser(token.value, domainName.value);

  if (userjson.status === 401 || userjson.status === 403) {
    const t = await getAccessTokenGameCenter(token.value !== null);
    token.value = t
    setTokenStr(t)
    await Delay(1000)
    testGetAccessTokenGameCenter()
    return
  }

  const user = await userjson.json()
  userObj.value = JSON.stringify(user);
}

function setTokenStr(token: string) {
  tokenstr.value = `${token.slice(0, 4)}...${token.slice(token.length - 5, token.length - 1)}`
}

async function getAccessTokenGameCenter(refresh?: boolean): Promise<string> {
  const token = await requestAccessTokenGameCenter(typeof window.webkit !== 'undefined', typeof window.Android !== 'undefined', refresh);
  return token
}

onMounted(async () => {
  const domain = await requestWLDomain(isIOS.value, isAndroid.value)
  domainName.value = domain
  testGetAccessTokenGameCenter()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h1", {
          class: "h1 secondary-font",
          innerHTML: _ctx.$t('home.title')
        }, null, 8, _hoisted_2),
        _createElementVNode("button", {
          class: "btn text",
          onClick: _cache[0] || (_cache[0] = () => testGetAccessTokenGameCenter())
        }, "Click me to refresh user..."),
        (_unref(isIOS))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", null, "Token value : " + _toDisplayString(tokenstr.value), 1)
            ]))
          : (_unref(isAndroid))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", null, "Token value : " + _toDisplayString(tokenstr.value), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)),
        _createElementVNode("div", null, [
          _hoisted_10,
          _createTextVNode(" " + _toDisplayString(domainName.value) + " ", 1),
          _hoisted_11,
          _createElementVNode("div", null, _toDisplayString(userObj.value), 1)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})